import { createFileRoute, redirect } from '@tanstack/react-router'

// Back-compat: the Config Browser page was retired in the unified UI. Point
// legacy bookmarks at Demo Info, which now carries the demo access/config
// details it used to surface.
export const Route = createFileRoute('/configuration')({
  beforeLoad: () => {
    throw redirect({ to: '/demoinfo' })
  },
})
